import { UserModel, OrgModel } from 'src/app/store/storeModels/user.model';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as io from 'socket.io-client';
import { Store } from '@ngrx/store';
import { interval, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { GeneralService } from './general.service';
import { AppState } from '../store/app.state';
import { Endpoints } from '../shared/config/endpoints';
@Injectable({
  providedIn: 'root'
})
export class ChatService {
  socket: any;
  readonly socketUrl: string =  environment.chatServiceUrl;
  private inactivityTimeout: any;
  // private readonly INACTIVITY_LIMIT = 10000; 
  // private readonly HEARTBEAT_INTERVAL = 30000;
  private api = this.endpoint.chatServiceUrl;
  private orgId: string;
  private org: OrgModel;
  private user: UserModel; 
  public userIsAgent = false;
  public heartbeatInterval: any;
  public lastHeartbeatTimestamp: number;
  public heartbeatMonitorInterval: any;
  private userUniqueId = '';
  public isAgentIdle: boolean;
  public channel = new BroadcastChannel('app-activity');
  public isLeader = false;
  public isListenerInit = false;
  public debouncedResetInactivity: () => void;

  constructor(
    private http: HttpClient,
    private endpoint: Endpoints,
    store: Store<AppState>, 
    private gs: GeneralService) {
    store.select('userInfo').subscribe(info => {
      this.orgId = info.organization.id + '';
      this.org = info.organization;
      this.user = info.user;
      this.userUniqueId = `${this.user.id}-${this.orgId}`;
      this.userIsAgent = !!info.isAgent;
    });

    this.debouncedResetInactivity = this.debounce(this.resetInactivityTimer.bind(this), 300);


    const socketQuery = { userId: this.user.id, orgId: this.org.id, uniqueId: this.userUniqueId };
    this.socket = io(this.socketUrl, { query: socketQuery });

    this.socket.on('connect', () => {
      if (!this.userIsAgent) return;
      this.isAgentIdle = false;
      this.getOnlineAgent().subscribe();
      this.getOnlineAgents();
      this.setAgentOnline();               
      this.setupInactivityListener();
      this.startHeartbeat(); 
      this.initAgentSession()
    });
  
    this.setupBrowserCloseListener();

    this.socket.on('disconnect', () => {
      if (this.heartbeatInterval) {
        clearInterval(this.heartbeatInterval);
        clearInterval(this.heartbeatMonitorInterval);
      }
    });
    
  }
  
  public setupInactivityListener() {
    if (this.isListenerInit) return;
    this.isListenerInit= true;
    this.resetInactivityTimer();
    window.addEventListener('mousemove', this.resetInactivityTimer.bind(this));
    window.addEventListener('keydown', this.resetInactivityTimer.bind(this));
    window.addEventListener('scroll', this.resetInactivityTimer.bind(this));
    window.addEventListener('touchstart', this.resetInactivityTimer.bind(this));
    document.addEventListener('visibilitychange', this.handleVisibilityChange.bind(this));
  }  

public setupRemoveListener() {
    if (!this.isListenerInit) return;
    this.isListenerInit= false;
    this.resetInactivityTimer();
    window.removeEventListener('mousemove', this.resetInactivityTimer.bind(this));
    window.removeEventListener('keydown', this.resetInactivityTimer.bind(this));
    window.removeEventListener('scroll', this.resetInactivityTimer.bind(this));
    window.removeEventListener('touchstart', this.resetInactivityTimer.bind(this));
    document.removeEventListener('visibilitychange', this.handleVisibilityChange.bind(this));
  }  

public resetInactivityTimer() {
  if (!this.isLeader) return;

  clearTimeout(this.inactivityTimeout);
  this.inactivityTimeout = setTimeout(() => {
    this.setAgentIdle();
  }, 180000);

  if (this.isAgentIdle) {
    this.setAgentOnline();
  }
}

public startHeartbeatMonitor() {
  this.lastHeartbeatTimestamp = Date.now();

  this.heartbeatMonitorInterval = setInterval(() => {
    const now = Date.now();
    const elapsed = now - this.lastHeartbeatTimestamp;
    if (elapsed > 20000 && this.userIsAgent && this.isLeader) {
      console.warn('Heartbeat missing — setting agent offline.');
      this.disconnect_online_agent();
    }
  }, 10000);
}

 

public startHeartbeat() {
  clearInterval(this.heartbeatInterval);
  clearInterval(this.heartbeatMonitorInterval);
  this.heartbeatInterval = setInterval(() => {
    if (!this.isLeader) return;

    this.lastHeartbeatTimestamp = Date.now();

    if (document.hidden || this.isAgentIdle) {
      this.setAgentIdle(); 
    } else {
      this.setAgentOnline();
    }
  }, 10000);
  this.startHeartbeatMonitor();
}

  

public setupBrowserCloseListener() {
  window.addEventListener('beforeunload', () => {
    if (this.isLeader) {
      this.channel.postMessage('leader-gone');
      this.disconnect_online_agent();
    }
  });

  this.channel.onmessage = (event) => {
    if (event.data === 'leader-gone') {
      this.claimLeadership();
    } else if (event.data === 'current-leader') {
    }
  };
}


public handleVisibilityChange() {
  if (!this.isLeader || !this.userIsAgent) return;

  if (document.hidden) {
    this.setAgentIdle();
  } else if (this.isAgentIdle) {
    this.setAgentOnline();
  }
}


  public claimLeadership() {
  this.channel.postMessage('current-leader');
  if (!this.isLeader) {
     this.becomeLeader()
     this.setAgentOnline();
     console.log('Claiming leadership');
  }
}

public becomeLeader() {
  this.isLeader = true;
  this.setupInactivityListener();
  this.startHeartbeat();
}

public resignLeadership() {
  this.isLeader = false;
  this.setupRemoveListener();
  clearInterval(this.heartbeatInterval);
  clearInterval(this.heartbeatMonitorInterval);
  clearTimeout(this.inactivityTimeout);
}

  initAgentSession() {
   document.addEventListener('visibilitychange', () => {
   
      setTimeout(() => {
         if (document.visibilityState === 'visible') {
              this.claimLeadership()
         }else{
          this.resignLeadership()
         }
      }, 500) 
  });
    if (!this.userIsAgent) return;
    this.isAgentIdle = false;
    this.getOnlineAgent().subscribe();
    this.getOnlineAgents();
    this.setAgentOnline();
    this.setupInactivityListener();
    this.startHeartbeat();
    this.channel.onmessage = (event) => {
    if (event.data === 'current-leader') {
      console.log("leading")
    }
  };
  }

  public debounce(func: Function, wait: number) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }
  
  



  listen(eventName: string): Observable<any> {
    return new Observable(subscriber => {
      this.socket.on(eventName, data => {
        subscriber.next(data);
      });
    });
  }

  emit(eventName: string, data: any): Observable<void> {
    return new Observable(subscriber => {
      this.socket.emit(eventName, data, () => {
        subscriber.next();
      });
    });
  }

  joinChat() {
    return this.socket.emit('User Joined-Chat', {
      id: this.user.id + this.orgId,
      org: this.orgId
    })
  }

  joinAgentNofication() {
    return this.emit('join_agent_notification', {
      uniqueId: this.userUniqueId,
      orgId: this.orgId
    });
   
  }
  joinOnlineAgents() {
    if(this.userIsAgent) {
      this.emit('join_online_agents', {
        user: {
          ...this.user,
          uniqueId: this.userUniqueId,
        },
        organization: this.org
      }).subscribe()
    }
  }
  disconnect_online_agent() {
    if(this.userIsAgent && this.isLeader) {      
      console.log('disconnected')
      this.emit('disconnect_online_agent', {}).subscribe()
    }
  }
  setAgentIdle() {
    if (this.userIsAgent) {
      this.emit('set_agent_idle', {
        org_id: this.orgId,
        userId: this.user.id
      }).subscribe();
      this.isAgentIdle = true;
    }
  }
  setAgentOnline() {
    if (this.userIsAgent) {
      this.emit('set_agent_online', {
        org_id: this.orgId,
        userId: this.user.id
      }).subscribe();
      this.isAgentIdle = false;
    }
  }
  getOnlineAgents() {
    this.isAgentIdle = false;
    return this.listen('online_agents');
  }

  getOnlineAgent() {
    this.isAgentIdle = false;
    return this.http.get(`${this.api}/availability/all-agents/${this.orgId}`);
  }
 
  autoAssignTicket(payload) {
    return this.http.post(`${environment.chatServiceUrl}/ticket/auto-assign`,  payload);
  }
 
 
  getAgentIncomingNotify() {
    return this.listen('agent_incoming_notification');
  }
  notifyAgents(payload: { agentList: any[], ticketCode: string, message: string}, internalGroupUsers: any[], user: {id, firstName, lastName, orgName} ) {
    let body = null;
    if(internalGroupUsers && internalGroupUsers.length > 0){
      const internalIDs = internalGroupUsers.map(internal => internal.id);
      const agents = payload.agentList.filter(agent => !internalIDs.includes(agent.userId));
      body = {
        creatorId: user.id,
        creatorName: `${user.firstName} ${user.lastName}`,
        orgName: user.orgName,//: this.org.name
        ticketCode: payload.ticketCode,
        agentList: agents,
        message: payload.message,
        ticketPageLink: `${environment.notchFrontendServiceUrl}/ticket/ticket-view/${payload.ticketCode}`,
        orgTicketEmail: 'noreply@notchcx.io',
        date: new Date(),
        service: 'tickets',
        subject: `@${user.firstName} ${user.lastName} mentioned you in Tickets`,
        template: 'mentioned you'
      }
      //this one sends to agents
      this.notifyAgentSocket(body);
      this.notifyAgentsEmail(body);
      //this has to send personalized messages to internal response persons
      const internalGroup = payload.agentList.filter(agent => internalIDs.includes(agent.userId));
      let response = null;
      for(let i =0; i < internalGroup.length; i++ ){
        const person = internalGroup[i];
        const {userId, name} = person;
        body.ticketPageLink = `${environment.notchFrontendServiceUrl}/internal-response/${payload.ticketCode}/${this.gs.org.id}/${userId}/${name}/${this.gs.org.name}`;
        body.agentList = [person];
        this.notifyAgentSocket(body);
        response = this.notifyAgentsEmail(body);
      }

      return response;
    }else{
      body = {
        creatorId: user.id,
        creatorName: `${user.firstName} ${user.lastName}`,
        orgName: user.orgName,
        ticketCode: payload.ticketCode,
        agentList: payload.agentList,
        message: payload.message,
        ticketPageLink: `${environment.notchFrontendServiceUrl}/ticket/ticket-view/${payload.ticketCode}`,
        orgTicketEmail: 'noreply@notchcx.io',//this.gs.orgEmailTicket,
        date: new Date(),
        service: 'tickets',
        subject: `@${user.firstName} ${user.lastName} mentioned you in Tickets`,
        template: 'mentioned you'
      }
      this.notifyAgentSocket(body);
      return this.notifyAgentsEmail(body);
    }
    
  }
  notifyAgentSocket(payload: { agentList: any[] }) {
    payload.agentList.forEach(agent => {
      this.emit('notify_agent_socket', {
        ...payload,
        agent: agent
      }).subscribe(() => {
      })
    })
  }
 
  saveAgentNotify(payload) {
    const body = {
      orgName: this.org.name,
      event: 'AGENT_MENTION',
      creatorId: this.user.id,
      creatorName: `${this.user.firstName} ${this.user.lastName}`,
      creatorTeams: [],
      itemId: payload.ticketCode,
      orgId: this.org.id,
      service: 'tickets',
      userIds: payload.userIds,
      subject: `@${this.user.firstName} ${this.user.lastName} mentioned you in Tickets`,
      template: 'mentioned you',
      email_list: payload.email_list
    }
    return this.http.post(environment.notificationsServiceUrl + '/notifications/action/user', body)
  }

  notifyAgentsEmail(payload) {
    const body = {
      ...payload,
      agentList: payload.agentList.map(agent => agent.email)
    }
    return this.emit('notify_agents_email', body);
  }
  
 
}